import * as React from 'react';
import { ForwardedRef, forwardRef } from 'react';
import { Textarea as TextareaUi, ITextareaProps } from '@cian/ui-kit';

import * as styles from './styles.css';

export const Textarea = forwardRef((props: ITextareaProps, ref?: ForwardedRef<HTMLTextAreaElement>) => {
  return (
    <div className={styles.wrapper}>
      <TextareaUi ref={ref} {...props} />
    </div>
  );
});

Textarea.displayName = 'Textarea';
